module.exports = __webpack_public_path__ + "img/code-bg.37dba1f2.png";